import type { VoiceCommandDoc } from '../../../data/voiceCommandsDocs';
import { i18next } from '../../../i18n';

export const voiceCommandsSectionLabelSx = {
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase' as const,
    color: 'var(--tg-theme-hint-color)',
    marginBottom: 8,
    display: 'block' as const,
};

export function voiceCommandsShortTabLabel(c: VoiceCommandDoc): string {
    return voiceCommandLabel(c);
}

export function voiceCommandLabel(c: VoiceCommandDoc): string {
    switch (c.id) {
        case 'quest':
            return i18next.t('voiceActionTypes.CREATE_QUEST');
        case 'postpone':
            return i18next.t('voiceActionTypes.POSTPONE_QUEST');
        case 'category':
            return i18next.t('voiceActionTypes.CREATE_CATEGORY');
        case 'achievement':
            return i18next.t('voiceActionTypes.CREATE_ACHIEVEMENT');
        default:
            return c.name;
    }
}
